import { ID } from "@libs/interfaces/layouts";
import { IUser } from "@/settings/zustand";
import { IProject } from "../interfaces";

export default function getSchoolUniqTutors (schoolId: ID, allProjectsList: IProject[] ) {
    let uniqTutors: (IUser | undefined)[] = [] 
    let tutors: (IUser | undefined)[] = []
    allProjectsList
        .filter((project: IProject) => {
            const school = project.fmru_school[0]
            return school?.id === schoolId
        })
        .forEach((project: IProject) => { 
            tutors = [
                project.tutor
            ]
            .filter(user => !!user?.id)
            .filter(user => {
                return !uniqTutors.find(usr => usr?.id === user?.id && !!user?.id)
            })
            uniqTutors = [
                ...uniqTutors,
                ...tutors
            ]
        }) 
    return uniqTutors;// as IUser[]
}